import { useMutation } from "@tanstack/react-query";
import { uploadMedia as apiUploadMedia } from "../../api/apiMedias";
import { toast } from "react-hot-toast";
import getErrorMessageFromAxiosError from "../../utils/parseError";

export function useUploadMedia() {

    const {
        mutate: uploadMedia,
        isPending,
        data: results,
        error,
    } = useMutation({
        mutationFn: (req) => apiUploadMedia(req),
        // onSuccess: (response) => {
        //     toast.success(response.message);
        // },
        onError: (err) => {
            console.error("Error:", err);
            const msg = getErrorMessageFromAxiosError(err, "Something Wont Wrong!");
            toast.error(msg);
        },

    });

    return { isPending, error, uploadMedia, results };
}
